export default window._cmsContent['solar/thank-you']